<template>
	<section class="main_left_sidesec" :class="{main_left_sidesec_icons:isFlipped}">
		<div class="top_logosec" :class="{'p-0':isFlipped}">
			<router-link :to="'/Users/dashboard'">
				<div class="logoAnimation">
					<img 
						:class="{fadeInLogoDashboard:isFlipped}"  
						src="../../../../static/prism/images/dashboard_logo_left.svg" 
						alt="#" 
						class="logoAnimateLeft" 
					/>
					<img 
						v-if="isFlippedImg==false" 
						:class="{displayNone:isFlipped}" 
						src="../../../../static/prism/images/dashboard_logo_right.svg" 
						alt="#" 
						class="logoAnimateRight hideOnSmallScreen" 
					/>
				</div>
				<!-- <img v-else src="../../../../static/prism/images/shoonya_icon-png.png" alt="#" class="logo_sec fadeIn" /> -->
			</router-link>
		</div>
		<div class="prism_menusec">
			<ul class="nav navbar-nav">
				<li>
					<router-link :class="{main_left_sidesec_icons_a:isFlipped}" :to="'/Users/dashboard'">
						<img src="../../../../static/prism/images/dashboradIcon.svg" alt="#" class="logo_sec" /> Dashboard
					</router-link>
				</li>
				<li @click="Callfunc('ManageAccounts.FinancialLedger', '')">
					<a :class="{'main_left_sidesec_icons_a':isFlipped, 'router-link-exact-active':isManageAccount}" href="javascript:void(0)">
						<img src="../../../../static/prism/images/manageAccountIcon.svg" alt="#" class="logo_sec" /> Manage Account
					</a>
				</li>
				<li @click="Callfunc('couponList.couponList', '')">
					<a :class="{'main_left_sidesec_icons_a':isFlipped, 'router-link-exact-active':isCoupons}" href="javascript:void(0)">
						<img src="../../../../static/prism/images/couponsIcon.svg" alt="#" class="logo_sec" /> Coupons
					</a>
				</li>
				<li>
					<router-link :class="{main_left_sidesec_icons_a:isFlipped}" :to="'/services/index/requestServiceElement'">
						<img src="../../../../static/prism/images/servicesIcon.svg" alt="#" class="logo_sec" /> Services
					</router-link>	
				</li>
				<li>
					<router-link :class="{main_left_sidesec_icons_a:isFlipped}" :to="'/faq'">
						<img src="../../../../static/prism/images/faqicon.svg" alt="#" class="logo_sec" /> FAQ's
					</router-link>	
				</li>
				<!-- <li>
					<router-link :to="'/ManageAccounts/financial-ledger'">
					 	<span>Financial Ledger </span> 
					</router-link>
				</li>
				<li>
					<router-link :to="'/ManageAccounts/closed-position'"><span>Closed Position</span></router-link>
				</li>
				<li title="Leverage" class="dropdown" @click="cleanStore()">
					<router-link :to="'/LeverageIndex'"><i class="fa fa-balance-scale"></i>  </router-link>
				</li>
				<li class="dropdown shoonyalogin-icon">
					<router-link :to="'/mutual-fund'" ><i data-feather="folder"></i></router-link>
				</li>
				<li class="dropdown"> 
					<router-link :to="'/api'"  @click="cleanStore()" title="Get API">
						<span class="icon-getAPI f-20"></span>
					</router-link>
				</li>
				<li class="dropdown shoonyalogin-icon">
					<router-link :to="" ><img src="../../../../static/prism/images/shoonya_icon_svg.svg" alt="#" class="logo_sec" /></router-link>
				</li> -->
			</ul>
		</div>
		<!-- <div class="support_ticket">
			<a data-title="Chat With Us" href="https://direct.lc.chat/13534029/3" target="_blank()">
				<img src="../../../../static/prism/images/chat.svg" alt="#" />
			</a>
		</div> -->
		<!-- <div class="dashboardFooterLogo" :class="{dashboardFooterLogoFlipped:isFlipped}" > -->
		<div class="dashboardFooterLogo" :class="{dashboardFooterLogoFlipped:isFlipped}">
			<img :class="{fadeInLogoDashboard:isFlipped}" src="../../../../static/prism/images/left-navigation-logo-icon.svg" alt="#" />
			<img :class="{displayNone:isFlipped}"  class="hideOnSmallScreen" src="../../../../static/prism/images/left-navigation-logo.svg" alt="#" />
		</div>
		<div class="left_slide_btn" @click="minimizeSidebar()">
			<span>
				<img :class="{flipped:isFlipped}" src="../../../../static/prism/images/navCollapsIcon.svg" alt="#" />
			</span>
		</div>
	</section>
</template>
<script>
import { Const } from '@/plugins/prism/provider/candle-history/lib/const.cls'
import { prismMixins } from '@/plugins/prism'
import { scalpertMixins } from '@/plugins/scalpert'
import { FileTextIcon, ColumnsIcon, TagIcon, RefreshCcwIcon } from 'vue-feather-icons'

export default {
	name: 'PrismApp',
	mixins: [prismMixins, scalpertMixins],
	data() {
		return {
			iconname: "layout",
			coupon_list: [],
			earned_rewards: 0,
			claim_rewards: 0,
			isFlipped:false,
			isFlippedImg:false,
			isManageAccount:null,
			isCoupons:null
		}
	},
	watch:{
		$route(val){
			if(val.name.includes("ManageAccounts")){
				this.isManageAccount = true;
			}
			else{
				this.isManageAccount = false;
			}
			if(val.name.includes("couponList") || val.name.includes("referred-clients")){
				this.isCoupons = true;
			}
			else{
				this.isCoupons = false;
			}
			
		}
	},
	methods: {
		Callfunc(getparameter1, getparameter2) {
			let json = {
				name: getparameter1
			}
			if (getparameter2 != '') {
				json['params'] = { 'tabName': 'requestServiceElement' }
			}
				this.$router.push(json);
				this.cleanStore();
		},
		checkscratch() {
			if ('list_data' in this.scratch_coupon) {
				var data_length = this.scratch_coupon.list_data.filter(data => data.scratch == 0).length
				return (data_length > 0)
			} else {
				return false
			}
		},
		minimizeSidebar() {
			if(this.isFlipped==false){
				this.isFlipped = true;
				// this.isFlippedImg = true;
				setTimeout(() => this.isFlippedImg = true, 500);
			}
			else{
				this.isFlipped = false;
				this.isFlippedImg = false;
				// setTimeout(() => this.isFlippedImg = false, 200);
			}
		}
	},
	created() {
		if(this.$route.name.includes("ManageAccounts")){
			this.isManageAccount = true;
		}
		else{
			this.isManageAccount = false;
		}
		if(this.$route.name.includes("couponList") || this.$route.name.includes("referred-clients")){
			this.isCoupons = true;
		}
		else{
			this.isCoupons = false;
		}
		//=========================holding-position-order-margin-info-trade=======
		if (localStorage.getItem("margin_info")) {
			var retrievedData = localStorage.getItem("margin_info");
			var recieveData = JSON.parse(retrievedData);
			this.$store.commit(Const.SET_MARGIN_LIST, recieveData);
		}

		//========================================================================
		if (parseInt(this.get_user.is_nest_user) == 0) {
			let non_nest_user_data =
			{
				"rout": this.rout,
				"parameter": this,
				"is_nest_user": "nest_user",
				"mutation_variable": "SET_POSITION_HOLDING_ORDER_LIST"
			};
			this._runGetListingData(non_nest_user_data)
		} else {
			let position_holding_order_json =
			{
				"platform": "TRADER",
				"page": "DASHBOARD",
				"rout": this.rout,
				"parameter": this,
				"mutation_variable": "SET_POSITION_HOLDING_ORDER_LIST"
			};
			this._runGetListingData(position_holding_order_json)
		}

		//<!---->
		if (parseInt(this.get_user.is_nest_user) == 0) {
			let non_nest_user_data =
			{
				"rout": this.rout,
				"parameter": this,
				"is_nest_user": "nest_user",
				"mutation_variable": "SET_POSITION_KSOFT_HOLDING_ORDER_LIST"
			};
			this._runGetListingData(non_nest_user_data)
		}

		//====================leverage==========================================
		//this._runGetUserLeverage({"parameter" : this , "page" : "dashboard"})

	},
	components: {
		FileTextIcon,
		ColumnsIcon, TagIcon, RefreshCcwIcon
	},
	mounted() {
		// $('.dropdown').click(function () {
		// 	$(this).addClass('active').siblings().removeClass('active');
		// });
	}
}
</script>
<style>
/* .dashboardFooterLogo{
	
   
} */
.dashboardFooterLogo img{
	position: absolute;
    bottom: 140px;
    left: 102px;
}
.dashboardFooterLogoFlipped img{
	left: 20px;
}
@media (max-width: 990px){
	.dashboardFooterLogo img{
		left: 20px;
	}
}
@media (max-width: 770px){
	.dashboardFooterLogo{
		display: none;
	}
}
@media (max-height: 640px){
	.dashboardFooterLogo img{
		bottom: 10px;
	}
}
@media (max-height: 510px){
	.dashboardFooterLogo{
		display: none;
	}
}
.flipped{transform: rotate(180deg);}
.prism_menusec .router-link-exact-active  {
    color: #fff !important;
    background: linear-gradient(89.26deg, #F09428 -7.32%, #F1B458 92.2%), 
	linear-gradient(180deg, rgba(255, 255, 255, 0.32) 0%, rgba(255, 255, 255, 0) 100%) !important;
}
.prism_menusec .router-link-exact-active img{filter: grayscale(431);}
/* .logoWithBg{
	width: 300px;
	text-align: center;
    position: fixed;
    left: 0;
    z-index: 1111;
    background: #000000;
} */
.logoAnimation{
	position: relative;
}
.logoAnimateLeft{
	width: 48px;
    position: absolute;
    z-index: 1;
	transition: all 0.4s;
    -webkit-transition: all 0.4s;
}
.logoAnimateRight{
	width: 130px;
    position: absolute;
    z-index: 0;
	/* left: 50px; */
	right: 8px;
	transition: all 0.4s;
    -webkit-transition: all 0.4s;
}
.displayNone{
	display: none;
}
.fadeInLogoDashboard{
	animation-name: fadeInLogoDashboard;
	-webkit-animation-name: fadeInLogoDashboard;	

	animation-duration: 1.5s;	
	-webkit-animation-duration: 1.5s;

	animation-timing-function: ease-in-out;	
	-webkit-animation-timing-function: ease-in-out;		

	visibility: visible !important;	
}

@keyframes fadeInLogoDashboard {
	0% {
		transform: scale(1);
		opacity: 1;		
	}
	50% {
		transform: scale(1.1);
		opacity: 1;		
	}
		
	100% {
		transform: scale(1);
		opacity: 1;	
	}		
}

@-webkit-keyframes fadeInLogoDashboard {
	0% {
		-webkit-transform: scale(1);
		opacity: 1;		
	}
	50% {
		-webkit-transform: scale(1.1);
		opacity: 1;	
	}
		
	100% {
		-webkit-transform: scale(1);
		opacity: 1;	
	}		
}
</style>


// WEBPACK FOOTER //
// src/components/prism/shared/left_navigation.vue